import React from "react";
import { connect } from "react-redux";
import ImageContainer from "@components/imageContainer";
import { CommonProps } from "@utils/interface";
import { getWidgetSpecificIsVisible } from "@utils/index";
import {
  Container,
  SectionContainer,
  SectionHeading,
  ItemsContainer,
  Item,
  ItemIcon,
  ItemContent,
  ItemName,
  ItemDescription,
  LearnMoreLink,
  LearnMoreText
} from "./styles";
import CloneChildren from "@components/children";

export interface ICoveredNotCoveredItem {
  display_name: string;
  description: string;
  image: string;
  show_learn_more?: boolean;
}

export interface ICoveredNotCoveredDetails extends CommonProps {
  heading: string;
  iterable_data: ICoveredNotCoveredItem[];
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const CoveredNotCoveredDetails = (props: ICoveredNotCoveredDetails) => {
  const { heading, iterable_data, styles, is_visible, actions, children } =
    props;
  const { on_learn_more_click } = actions || {};
  if (!is_visible) return null;

  return (
    <Container styles={styles}>
      <SectionContainer>
        <SectionHeading>{heading}</SectionHeading>
        <ItemsContainer>
          {iterable_data?.map((item, index) => (
            <Item key={index}>
              <ItemIcon>
                <ImageContainer
                  imgSrc={item.image}
                  alt={item.display_name}
                  width={40}
                  height={40}
                />
              </ItemIcon>
              <ItemContent>
                <ItemName>{item.display_name}</ItemName>
                <ItemDescription>
                  {item.description} <br />
                  {item.show_learn_more && (
                    <LearnMoreLink
                      onClick={() => {
                        on_learn_more_click?.forEach((eachFunc: any) => {
                          if (typeof eachFunc.funCall === "function") {
                            eachFunc.funCall(eachFunc.args);
                          }
                        });
                      }}
                    >
                      <LearnMoreText>Learn more</LearnMoreText>
                    </LearnMoreLink>
                  )}
                </ItemDescription>
              </ItemContent>
            </Item>
          ))}
        </ItemsContainer>
      </SectionContainer>
      {children && <CloneChildren>{children}</CloneChildren>}
    </Container>
  );
};

export default connect(mapStateToProps)(CoveredNotCoveredDetails);
